import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';

const DataContext = createContext();

const STATUSES = ['Submitted', 'Assigned', 'Engineer on the way', 'In progress', 'Resolved'];

const DEMO_HOME = { lat: 51.5074, lng: -0.1278 };
const DEMO_ENGINEER = { lat: 51.5150, lng: -0.1400 };

export const DataProvider = ({ children }) => {
  const { user } = useAuth();
  const [claims, setClaims] = useState([]);

  const key = user ? `dhs-claims-${user.id}` : null;

  useEffect(() => {
    if (!key) { setClaims([]); return; }
    const stored = localStorage.getItem(key);
    setClaims(stored ? JSON.parse(stored) : []);
  }, [key]);

  const save = (next) => {
    setClaims(next);
    if (key) localStorage.setItem(key, JSON.stringify(next));
  };

  const addClaim = (data) => {
    const claim = {
      id: 'CLM-' + Math.floor(1000 + Math.random() * 9000),
      createdAt: new Date().toISOString(),
      status: 'Submitted',
      engineer: null,
      engineerLocation: DEMO_ENGINEER,
      customerLocation: DEMO_HOME,
      scheduled: null,
      updates: [{ at: new Date().toISOString(), text: 'Submitted by customer' }],
      ...data,
    };
    save([claim, ...claims]);
    return claim;
  };

  const advanceStatus = (id) => {
    const next = claims.map((c) => {
      if (c.id !== id) return c;
      const i = STATUSES.indexOf(c.status);
      const ns = STATUSES[Math.min(i + 1, STATUSES.length - 1)];
      return { ...c, status: ns, updates: [...c.updates, { at: new Date().toISOString(), text: `Status: ${ns}` }] };
    });
    save(next);
  };

  const updateEngineerLocation = (id, loc) => {
    const next = claims.map((c) => c.id === id ? { ...c, engineerLocation: loc } : c);
    save(next);
  };

  return (
    <DataContext.Provider value={{ claims, addClaim, advanceStatus, updateEngineerLocation, STATUSES }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);
